<template>
	<div>
		<v-card flat v-show="editor">
			<v-card-text>
				<brace
					style="height:90vh;"
					class="kbet-editor"
					:mode="'json'"
					@code-change="onEditorCodeChange"
					@setHandler="
						h => {
							editorHandler = h;
						}
					"
				/>
			</v-card-text>
		</v-card>
		<v-card flat v-show="!editor" v-if="tableLogResult.length > 0">
			<v-card-text>
				<div style="overflow-x:auto;padding:1%;">
					<div class="tableLight" id="results">
						<div class="theader">
							<div
								v-for="head in Object.keys(tableLogResult[0])"
								:key="head"
								:class="['table_header', 'table_header_light']"
							>
								{{ head }}
							</div>
						</div>
						<div
							v-for="(row, key) in tableLogResult"
							:key="key"
							:class="['table_row', row['RESULT'] != 0 ? 'mildRed' : '']"
						>
							<div
								v-for="(rowItem, itemKey) in row"
								:key="itemKey"
								class="table_small"
							>
								<div class="table_cell">{{ itemKey }}</div>
								<div
									class="table_cell"
									style="text-align:left;margin: 0 20px 0 0;"
								>
									{{ rowItem }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</v-card-text>
		</v-card>
		<v-btn
			color="blue darken-1"
			small
			absolute
			top
			right
			fab
			@click="toggleLogDisplay"
			style="top: 80px;"
		>
			<v-icon>{{ editor ? 'table_chart' : 'code' }}</v-icon>
		</v-btn>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn
					color="green darken-1"
					small
					absolute
					top
					right
					fab
					@click="onExtract"
					v-on="on"
					style="top: 140px;"
				>
					<v-icon>check_circle</v-icon>
				</v-btn>
			</template>
			<span>AI Extract - Accept and extract data using AI-generated meta</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn
					color="red darken-1"
					small
					absolute
					top
					right
					fab
					@click="onReject"
					v-on="on"
					style="top: 200px;"
				>
					<v-icon>cancel</v-icon>
				</v-btn>
			</template>
			<span>Reject - Reject AI-generated meta for this file</span>
		</v-tooltip>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	data() {
		return {
			editorHandler: false,
			displayJSON: false,
			editor: false,
			tableLogResult: [],
		};
	},
	created() {},
	methods: {
		...mapActions('aiMetaMap', ['getExtractedData', 'extractFile', 'rejectFile']),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapMutations('aiMetaMap', ['refreshListEmitter', 'closeFileMetaDialog']),
		onEditorCodeChange(code) {
			this.editorCode = code;
		},
		toggleLogDisplay() {
			this.editor = !this.editor;
		},
		onExtract() {
			if (
				window.confirm(
					'Are you sure you want to accept and extract using AI-generated meta?'
				)
			) {
				this.openLoaderDialog();
				this.extractFile({ uuid: this.selectedFile.uuid }).then(data => {
					this.closeLoaderDialog();
					if (data) {
						this.openSnackbar({
							text: 'AI Extract completed successfully',
						});
						this.refreshListEmitter();
						this.closeFileMetaDialog();
					} else {
						this.openSnackbar({
							text: 'Failed to extract file',
						});
					}
				});
			}
		},
		onReject() {
			if (
				window.confirm(
					'Are you sure you want to reject the AI-generated meta for this file?'
				)
			) {
				this.openLoaderDialog();
				this.rejectFile({ uuid: this.selectedFile.uuid }).then(data => {
					this.closeLoaderDialog();
					if (data) {
						this.openSnackbar({
							text: 'File rejected successfully',
						});
						this.refreshListEmitter();
						this.closeFileMetaDialog();
					} else {
						this.openSnackbar({
							text: 'Failed to reject file',
						});
					}
				});
			}
		},
	},
	computed: {
		...mapGetters('aiMetaMap', ['selectedFile']),
	},
	mounted() {
		this.getExtractedData({
			uuid: this.selectedFile.uuid,
		}).then(data => {
			if (data && data.ok) {
				this.tableLogResult = JSON.parse(JSON.stringify(data.data));
				this.editorHandler.setValue(JSON.stringify(data.data, null, 2));
			}
		});
	},
	watch: {},
	props: [],
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
.code {
	width: 100%;
	font-size: 14px;
	padding: 1%;
}
.mildRed {
	background: lightcoral;
}
.tableLight {
	display: table;
	text-align: center;
	width: 100%;
	margin: 1% auto 0;
	border-collapse: separate;
	font-weight: 400;
}
.table_row {
	display: table-row;
}
.theader {
	display: table-row;
	text-align: left;
}
.table_header {
	padding-top: 10px;
	padding-left: 10px;
	padding-bottom: 10px;
	font-weight: 700;
}
.table_header_light {
	display: table-cell;
	border-bottom: #808080 1px solid;
	background: #f0f0f0;
	color: #000;
}
.table_header_light:hover {
	cursor: pointer;
}
.table_small {
	display: table-cell;
}
.table_row > .table_small > .table_cell:nth-child(odd) {
	display: none;
	padding-top: 3px;
	padding-bottom: 3px;
	min-width: 120px;
}
.table_row > .table_small > .table_cell {
	padding-top: 3px;
	padding-bottom: 3px;
	min-width: 120px;
}
@media screen and (max-width: 1200px) {
	.table {
		width: 100%;
	}
}
@media screen and (max-width: 700px) {
	.table {
		display: block;
		width: 100%;
	}
	.table_row:nth-child(2n + 3) {
		background: none;
	}
	.theader {
		display: none;
	}
	.table_row > .table_small > .table_cell:nth-child(odd) {
		display: table-cell;
		width: 50%;
	}
	.table_cell {
		display: table-cell;
		width: 50%;
	}
	.table_row {
		display: table;
		width: 100%;
		border-collapse: separate;
		padding-bottom: 20px;
		margin: 5% auto 0;
		text-align: center;
	}
	.table_small {
		display: table-row;
	}
	.table_row > .table_small:first-child > .table_cell:last-child {
		border-left: none;
	}
	.table_row > .table_small:last-child > .table_cell {
		border-bottom: #ccc 1px solid;
	}
	.table_row > .table_small > .table_cell:first-child {
		border-left: #ccc 1px solid;
	}
	.table_row > .table_small:first-child > .table_cell:first-child {
		border-top-left-radius: 5px;
		border-top: #ccc 1px solid;
	}
	.table_row > .table_small:first-child > .table_cell:last-child {
		border-top-right-radius: 5px;
		border-top: #ccc 1px solid;
	}
	.table_row > .table_small:last-child > .table_cell:first-child {
		border-right: none;
	}
	.table_row > .table_small > .table_cell:last-child {
		border-right: #ccc 1px solid;
	}
	.table_row > .table_small:last-child > .table_cell:first-child {
		border-bottom-left-radius: 5px;
	}
	.table_row > .table_small:last-child > .table_cell:last-child {
		border-bottom-right-radius: 5px;
	}
}
</style>
